module.exports = __webpack_public_path__ + "static/media/02 category.cdc780a7.jpg";